/*  Shared  */
import { Helpers, Notify, Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';
import i18n from 'i18n';

/*  React  */
import { useCallback, useEffect, useState } from 'react';

/*  Constants  */
const { isset } = Helpers;

const { t } = i18n;

export const useFetchTenantIdentifiers = ({ clientId, type }) => {
    const [subscriberSites, setSubscriberSites] = useState([]);

    const [loading, setLoading] = useState(false);
    // calling refetchData will force a rerender on the hook
    const [shouldRefetchData, setShouldRefetch] = useState({});

    const refetchData = () => setShouldRefetch({});

    useEffect(() => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            if (!clientId || clientId === '0') {
                setLoading(false);
                setSubscriberSites([]);
                return;
            }
            try {
                const response = await axios.get(
                    `/anm/subscribers/${clientId}`,
                    {
                        cancelToken: source.token,
                        params: { type }
                    }
                );
                if (!Response.hasData(response, { noId: true })) {
                    debug.e('No Sites Found', response);
                    setLoading(false);
                    setSubscriberSites([]);
                    return;
                }

                setSubscriberSites(Response.getData(response, { noId: true }));
                setLoading(false);
            } catch (err) {
                debug.e('Unable to fetch subscriber sites.', err);
                setLoading(false);
                setSubscriberSites([]);
            }
        };
        fetchData();

        return () => {
            // Cancel the request when the component unmounts
            source.cancel();
        };
    }, [clientId, type, shouldRefetchData]);

    return {
        loading,
        refetchData,
        subscriberSites
    };
};

export const usePostSubscriberSite = (params) => {
    const [saving, setSaving] = useState(false);

    const postSubscriberSite = useCallback(async () => {
        const { value } = params;

        if (isset(value, 'id')) {
            return true;
        }
        if (!isset(value)) {
            Notify.error(t('TenantIdentifier.subscriber.linkFailure'));
            return false;
        }

        try {
            setSaving(true);
            await axios.post('/tenantIdentifier', params);
            Notify.success(t('TenantIdentifier.subscriber.linkSuccess'), {
                seconds: 10
            });
            setSaving(false);
            return true; // success = true
        } catch (err) {
            debug.e('Unable to merge users.', err);
            Notify.error(t('TenantIdentifier.subscriber.linkFailure'));
            setSaving(false);
            return false; // success = false
        }
    }, [params]);

    return { postSubscriberSite, saving };
};
